// @flow

import { Link } from 'react-router-dom';

import { useTranslator } from '@gandi/translate';

type Props = { term: string };

export function SearchSimilarLink({ term }: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Link to={`/domain/suggest?search=${term}`}>
      {__('Find similar domain')}
    </Link>
  );
}
